<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.shipment_customs_code_hscode') || '报关HSCODE'"
            required
            :error="hscodeError"
          >
            <HscodeSelect
              :hscode="formData.hscode"
              @change="onHscodeChange"
              :categoryCode="formData.masterCategoryCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeName') || '报关中文名称'"
          >
            <el-input
              v-model="formData.hscodeName"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_hscodeNameEn') || '报关英文名称'"
          >
            <el-input
              v-model="formData.hscodeNameEn"
              :placeholder="
                $l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
              "
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="mini">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="mini">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import HscodeSelect from '../hscode-select'
export default {
  mixins: [EditLoading],
  components: { HscodeSelect },
  props: {
    shipmentCode: { type: String, default: '' },
    listGoods: { type: Array, default: () => [] },
  },
  data() {
    return {
      formData: {
        hscode: '',
        hscodeName: '',
        hscodeNameEn: '',
        masterCategoryCode: '',
      },
      backDialogVisible: false,
      hscodeError: '',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const firstGoods = this.listGoods[0]
      const {
        hscode,
        hscodeName,
        hscodeNameEn,
        masterCategoryCode,
      } = firstGoods
      this.formData = { hscode, hscodeName, hscodeNameEn, masterCategoryCode }
    },
    onHscodeChange(e) {
      const { hscode = '', hscodeName = '', hscodeNameEn = '' } = e || {}

      this.hscodeError = !hscode
        ? this.$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
        : ''

      this.formData.hscode = hscode
      this.formData.hscodeName = hscodeName
      this.formData.hscodeNameEn = hscodeNameEn
    },
    async save() {
      const { hscode } = this.formData
      if (!hscode) {
        this.backDialogVisible = false
        this.hscodeError =
          this.$l('INDEX.form_placeholder_hscode') || '请选择报关HSCODE'
        return
      }

      const orderGoodsCodeList = this.listGoods.map(
        (item) => item.orderGoodsCode
      )

      const params = {
        shipmentCode: this.shipmentCode,
        ...this.formData,
        orderGoodsCodeList,
      }

      this.loadingOpen()
      const res = await this.$api
        .shipmentHscodeGoodsSaveAndSyncCustomerGoodsApi(params)
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
